export const ONBOARDING_VIDEOS = {
  BUSINESS_HOURS: "https://www.loom.com/embed/26e2a788c10d4c9f9747f068d2a5ebb9",
  TEAM_SCHEDULE: "https://www.loom.com/embed/3852da7d9cfa4c9aab381c707d9dc6c4",
  ADD_SERVICE: "https://www.loom.com/embed/090e1d5570724d1abc42e59987aabb6d",
  LEARN_THE_SOFTWARE:
    "https://cuddlesapp.zendesk.com/hc/en-us/categories/4409667359899-How-to-Videos-",
};
